import React from 'react'

import BaseModal from 'components/Modals/BaseModal'
import { ConfirmationStatus } from 'components/Schedule'

const ScheduleConfirmationsModal = ({ _id }) => {
  return (
    <BaseModal title="manager.timeOffs.TIMEOFF_CONFIRMATION_STATUS_MODAL">
      <ConfirmationStatus _id={_id} isTimeOff />
    </BaseModal>
  )
}

export default ScheduleConfirmationsModal
